// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../public/css/font-awesome.css
// module id = 724
// module chunks = 0